import type { GlobalThemeOverrides } from 'naive-ui'

export const theme: GlobalThemeOverrides = {
  common: {
    primaryColor: '#a78bfa',
    primaryColorSuppl: '#a78bfa',
    primaryColorHover: '#c4b5fd',
    primaryColorPressed: '#8b5cf6',
    infoColor: '#096dd9',
    infoColorSuppl: '#096dd9',
    infoColorHover: '#2e8de6',
    infoColorPressed: '#0050b3',
    successColor: '#52c41a',
    successColorSuppl: '#52c41a',
    successColorHover: '#73d13d',
    successColorPressed: '#389e0d',
    warningColor: '#faad14',
    warningColorSuppl: '#faad14',
    warningColorHover: '#ffc53d',
    warningColorPressed: '#d48806',
    errorColor: '#f5222d',
    errorColorSuppl: '#f5222d',
    errorColorHover: '#ff4d4f',
    errorColorPressed: '#cf1322',
    borderRadius: '5px'
  },
  LoadingBar: {
    colorLoading: '#1890ff'
  },
  Input: {
    borderRadius: '5px',
    heightSmall: '32px',
    heightMedium: '42px',
    heightLarge: '48px',
    boxShadowFocus: 'none',
    boxShadowFocusError: 'none',
    boxShadowFocusWarning: 'none'
  },
  Button: {
    heightSmall: '32px',
    heightMedium: '42px',
    heightLarge: '48px',
    boxShadowFocus: 'none',
    boxShadowFocusError: 'none',
    boxShadowFocusWarning: 'none'
  },
  Checkbox: {
    borderRadius: '50%',
    boxShadowFocus: 'none',
    boxShadowFocusError: 'none',
    boxShadowFocusWarning: 'none'
  },
  Form: {
    feedbackFontSizeSmall: '12px',
    feedbackFontSizeMedium: '12px',
    feedbackPadding: '0'
  }
}
